import React from 'react'
import { Page } from '../../components/Page'
import '../creative.css'

function Desmond() {
  return (
    <Page>
      <div className="title"> 
        <h1> Desmond </h1>
      </div>
      <div className='creative-text'>

    The player first wakes up in the garden with little information about where or who he is. He soon learns that he has recently died, although he doesn’t know how, nor can he remember his previous life. To earn his next life, Desmond must work as the groundskeeper for a garden on the long path back to the human realm. Desmond must grow enough food at each level to satisfy whatever spirit stays at the inn that night. Unfortunately, the plants attract pesky spirits, which he must keep at bay. As Desmond progresses through the levels, he learns more about his past, uncovering the events leading up to his death and lost identity… Soon, Desmond begins to wonder why he is being forced to work in the garden for so long when so many other spirits are allowed to pass on to their next life.
    <br/><br/>
    By the end of the game, Desmond has discovered the real reason for his imprisonment in the garden. He learns that in his past life, he was a great military leader responsible for the deaths of thousands of people. His actions killed each spirit he served in the garden, and he can earn another shot at life.

    <br/><br/>
    Desmond is supposed to highlight the idea that our demons often arise as the products of our ambitions. Desmond first landed himself in the garden through his aspirations in his previous life, where he chased a role of power and influence. However, the byproducts of his many decisions caused him to face a more significant challenge in his personal afterlife. Now, in his afterlife, he must once again choose between chasing his ambition of another human life or simply accepting his current life as a spirit and finding peace in the garden. It is because of Desmond’s desire to grow that he finds himself in a constant fight.
    <br/><br/>
    <a href="https://youtu.be/P7JAl7Y1w7E">watch a playthrough of Desmond</a>
    

      </div>
    </Page>
  )
}

export default Desmond